import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';


@Component({
	selector: 'project-registration-finish',
	template: require('./project.registration.finish.html'),
})
export class ProjectRegistrationFinishComponent implements OnInit {
	@Input() projectForm: UntypedFormGroup;
	@Output() createProject: EventEmitter<void> = new EventEmitter<void>();

	inviteCount = 0;
	moduleList = [];
	parent = null;
	children = [];
	otherModuleNameDescription = '';

	constructor() { }

	ngOnInit(): void {
		// Initialization logic if needed
		const invites = this.projectForm.get('invites')?.value;
		if (invites) {
			this.inviteCount = invites.split(',').length;
		}

		const modules = this.projectForm.get('modules')?.value;
		if (modules) {
			this.moduleList = modules.split(',');
		}

		this.parent = this.projectForm.get('parentProject')?.value;
		const v = this.projectForm.get('children')?.value;
		if (v) {
			this.children = v;
		}

		this.otherModuleNameDescription = this.getOtherModuleNames();
	}

	moduleEnabled(moduleName) {
		return this.moduleList.includes(moduleName);
	}

	getOtherModuleNames() {

		const namesToCheck = {
			wiki: "Wiki",
			docman: "Document/File Management",
			build: "Build Tracking",
			frs: "Release Management"
		};

		const modNames = Object.keys(namesToCheck).reduce((carry: any, name: string) => {
			if (this.moduleEnabled(name)) {
				carry.push(namesToCheck[name]);
			}
			return carry;
		}, []);

		if (modNames.length === 0) return '';

		if (modNames.length === 1) return modNames[0];

		const lastElement = modNames.pop();
		return `${modNames.join(', ')} and ${lastElement}`;
	}
}